import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const dummyData = [
  {
    month: "Jan",
    vaccinated: 4000,
  },
  {
    month: "Feb",
    vaccinated: 3000,
  },
  {
    month: "March",
    vaccinated: 2000,
  },
  {
    month: "April",
    vaccinated: 2780,
  },
  {
    month: "May",
    vaccinated: 1890,
  },
  {
    month: "Jun",
    vaccinated: 2390,
  },
  {
    month: "July",
    vaccinated: 3490,
  },
];

const Barchart = (props) => {
  const height = props.height || 250;
  const width = props.width || "100%";
  const xAxisKey = props.xAxisKey || "month";
  const yAxisKey = props.yAxisKey || "Year-2022";
  const data = props.data || dummyData;

  return (
    <ResponsiveContainer width={width} height={height}>
      <BarChart
        width={width}
        height={height}
        data={data}
        style={{ height: height + 25 }}
        margin={{
          top: 5,
          right: 5,
          left: 5,
          bottom: 5,
        }}
        barSize={20}
      >
        <XAxis
          dataKey={xAxisKey}
          // scale="point"
          padding={{ left: 10, right: 10 }}
        />
        <YAxis type="number" domain={[0, 5000]} />
        <Tooltip />
        <Legend />
        <CartesianGrid strokeDasharray="3 3" />
        <Bar dataKey={yAxisKey} fill="#26ACF8" background={{ fill: "#eee" }} />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default Barchart;
